import type * as type from "@vTypes";
import type { ShiftManage } from "@vTypes/snapshot-type.ts";

/** 발행 스냅샷 `shift_manage[]` → `RosterMadeTable`용 월 최소인원 맵 (D/E/N/M/O) */
export function manPowerMonthlyFromShiftManage(
  shiftManager: ShiftManage | ShiftManage[]
): type.ManPowerMonthly | null {
  if (!Array.isArray(shiftManager)) return null;
  const managerMap = new Map<string, number>(
    shiftManager.map((item) => [item.main_code, item.manpower])
  );
  const defaultCodes = ["D", "E", "N", "M", "O"];
  return Object.fromEntries(
    defaultCodes.map((code) => [code, managerMap.get(code) ?? 0])
  );
}
